import React, { lazy, Suspense } from 'react';
import Layout from '../../components/layout/Layout';
import useSEO from '../../hooks/useSEO';
import { PAGE_SEO } from '../../utils/seo';
import Hero from './sections/Hero';

// Everything below the hero is off-screen on first paint, so it is split into its own chunks.
// This keeps framer-motion and the section code out of the critical path that gates LCP.
// The dashboard mock-up under the hero is switched off for now; restore this import, the
// <ProductVisual /> below and --next-overlap in CampusBackground.css to bring it back.
// const ProductVisual = lazy(() => import('./sections/ProductVisual'));
const FeatureHighlights = lazy(() => import('./sections/FeatureHighlights'));
const VersiAssistant = lazy(() => import('./sections/VersiAssistant'));
const AITimetable = lazy(() => import('./sections/AITimetable'));
const VideoShowcase = lazy(() => import('./sections/VideoShowcase'));
const AdmissionSection = lazy(() => import('./sections/AdmissionSection'));
const TeacherAppSection = lazy(() => import('./sections/TeacherAppSection'));
const FeeManagementSection = lazy(() => import('./sections/FeeManagementSection'));
const TestimonialsSection = lazy(() => import('./sections/TestimonialsSection'));
const TrustedBySection = lazy(() => import('./sections/TrustedBySection'));
const MicrosoftAcceleratorSection = lazy(() => import('./sections/MicrosoftAcceleratorSection'));
const OurPartnersSection = lazy(() => import('./sections/OurPartnersSection'));
const FeaturedIn = lazy(() => import('./sections/FeaturedIn'));

const Home = () => {
      // Set SEO meta tags for homepage
      useSEO({
            title: PAGE_SEO.home.title,
            description: PAGE_SEO.home.description,
            keywords: PAGE_SEO.home.keywords,
      });



      return (
            <Layout>
                  <div className="w-full">
                        <Hero />
                        {/* min-height reserves room for the incoming sections so nothing shifts */}
                        <Suspense fallback={<div className="min-h-screen" />}>
                              {(
                                    <>
                                          {/* <ProductVisual /> */}
                                          <FeatureHighlights />
                                          <VersiAssistant />
                                          <AITimetable />
                                          <VideoShowcase />
                                          <AdmissionSection />
                                          <TeacherAppSection />
                                          <FeeManagementSection />
                                          <TestimonialsSection />
                                          <TrustedBySection />
                                          <MicrosoftAcceleratorSection />
                                          <OurPartnersSection />
                                          <FeaturedIn />
                                    </>
                              )}
                        </Suspense>
                  </div>
            </Layout>
      );
};

export default Home;
